import Vuex from "vuex";
import mutations from "@/core/store/mutations";
import getters from "@/core/store/getters";

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: {
        appIsReady: false,
        websocketIsReady: false,
        currentUser: null,
        token: null,

        countryName: '',
        countryNameShort: '',
        countrySlug: '',

        location: {},
        price: [],
        features: {},
        services: [],
        category: {},
        settings: {},
        extraContent: {},

        searchOnlyWithPrivateGallery: false,

        filterOpened: false,
        venue: false,
        asia: false,
        locationTemp: {},
        priceTemp: [],
        featuresTemp: {},
        servicesTemp: [],
        categoryTemp: {},
        extraContentTemp: {},

        featureOptions: {},
        ranges: {},

        // default radius in escort search
        searchRadius: null,
        searchRadiusTemp: '20km',

        searchResponse: {
            users: [],
            total: null,
            current_page: 1,
            last_page: 1,
        },

        similarEscorts: [],
        savedSearchNewEscorts: [],

        preFetchedUser: null,
        seoView: null,
        isSeekingServicesProfile: false,
        searchScrollPosition: null,

        refreshSearch: null,
        searchStories: null,
        showStoriesCookieSet: false,
        loading: null,
        searchDoneFromHome: false,

        allServices: [],
        topServices: [],
        homeGirls: [],

        shouldReloadConversations: false,
        conversationUnreadMessageCount: null,
        selectedConversation: null,

        userProfileViewsNotificationCount: null,

        translate: {
            account: {
                cardCheckout: {},
                validation: {},
                placeholder: {},
                successMessage: {},
                referral: {},
                conversations: {
                    report: {},
                },
                creditsPage: {
                    bitcoinInfo: {},
                },
                reviews: {},
                modalPublishVerifyPhone: {},
                phoneVerification: {},
                vipPunterTopBanner: {},
                usefulLinks: {},
                featuresVenue: {},
                issue_types: [],
                photosGallery: {},
                creditBreakdown: [],
                gallery: {
                    accountCard: {},
                },
                privateGalleryWithdraw: {},
                format: {},
                managerPage: {},
                lockedProfile: {},
                meetingsContactsAlerts: {},
                onboard: {
                    tabs: {},
                    goldUpsell: {},
                },
            },
            home: {
                sexySanta: {},
                navBar: {},
                footer: {},
                bottomSeoText: {},
                h1TagReplacements: {},
                registrationModal: {},
            },
            login: {
                whatsappRegistration: {},
                emailVerification: {},
                phoneVerification: {},
                modalVerifyEmail: {},
                userRegistrationTypes: [],
                userRegistrationTypesDescription: {0: [], 2: []},
                modalRegisterGallery: {},
            },
            user_features: {
                validation: {},
                genders: {},
                breastsTypes: {},
                services: {},
                featureOptions: {},
            },
            cookie_banner: {},
            product: {
                description: {},
                productAdvantages: {},
                venueBuyGoldPage: {},
            },
            transaction: {},
        },

        regionData: {},

        locale: 'de',

        is404View: false,

        sexySantaBannerIsVisible: false,

        isManagerLoggedInAsEscort: false,
        managerAsEscortData: {},

        suggestedRedirectRegion: null,

        mainAccountComponentWasLoadedBefore: false,
        profileBlurredModalForceShow: false,

        pageChanges: {
            isDirty: false,
            onSave: () => undefined,
            onDiscard: () => undefined,
        },
        cdnProductionUrl: undefined,

        /**
         * @typedef {Object} TipProfileModalRedirector
         * @property {string} tipUsername
         * @property {number} tipAmount
         * @property {string} tipRedirectProfilePath
         */

        /**
         * @type {TipProfileModalRedirector|undefined}
         */
        tipProfileModalRedirector: undefined,
        userIsFromExplicitRegion: false,
        hideExplicitRegionAds: false,
    },

    mutations,
    getters,
});

export default store;
